import type { Control } from 'react-hook-form';
import { SelectControlled } from '@/components/form/select-controlled';
import { usePurchaseOrderDocumentTypeSelectOptions } from '@/features/purchase-order/hooks/use-purchase-order-document-type-select';
import type { PurchaseOrderDocumentFormValues } from '@/features/purchase-order/schema/purchase-order-document-form-schema';

type PurchaseOrderDocumentFormFieldsProps = {
  control: Control<PurchaseOrderDocumentFormValues>;
  documentTypeError?: string;
};

export function PurchaseOrderDocumentFormFields({
  control,
  documentTypeError,
}: PurchaseOrderDocumentFormFieldsProps) {
  const { documentTypeLabel, documentTypePlaceholder, isLoading, options } =
    usePurchaseOrderDocumentTypeSelectOptions();

  const selectOptions = options.map((option) => ({
    label: option.label,
    value: option.value,
  }));

  return (
    <SelectControlled
      control={control}
      error={documentTypeError}
      isLoading={isLoading}
      label={documentTypeLabel}
      name='documentTypeId'
      options={selectOptions}
      placeholder={documentTypePlaceholder}
    />
  );
}
